import { IAppState } from '../../store';

export const selectAnswerFormReviewId = (state: IAppState) => state.answerForm.reviewId;
